<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('reports')">Raporty</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      {{ form.name }}
    </h1>

    <trashed-message v-if="report.deleted_at" class="mb-6" @restore="restore">
      Raport jest oznaczony jako usunięty.
    </trashed-message>

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full" label="Nazwa" />

          <shtax-text-area-input class="pr-6 pb-8 w-full" textarea_classes="h-32" v-model="form.description" :error="form.errors.description" label="Opis" />

          <text-input v-model="form.command" :error="form.errors.command" class="pr-6 pb-8 w-full lg:w-1/2" label="Komenda" :disabled="true" />

          <multiselect-input v-model="form.users" :error="form.errors.users" class="pr-6 pb-8 w-full" :options="users" track_by="id" opt_label="name" label="Lista odbiorców" />

          <shtax-checkbox class="pr-6 pb-8 w-full lg:w-1/2" v-model:checked.sync="form.is_dependent" :error="form.errors.is_dependent" :checked="form.is_dependent" label="Raport zależny" />

          <template v-if="form.is_dependent">

            <multiselect-input v-model="form.period" :error="form.errors.period" class="pr-6 pb-8 w-full" :options="cycles" track_by="name" opt_label="name_pl" :multiple="false" :close_on_select="true" label="Cykl" />
            
            <template v-if="form.period != null">
                <template v-if="form.period.name == 'monthly'">
                    <text-input v-model="form.day_of_month" :error="form.errors.day_of_month" class="pr-6 pb-8 w-full lg:w-1/2" label="Dzień miesiąca" type="number" min="1" max="31" />
                </template>
                <template v-if="form.period.name == 'monthly' || form.period.name == 'daily'">
                    <text-input v-model="form.hour_of_day" :error="form.errors.hour_of_day" class="pr-6 pb-8 w-full lg:w-1/2" label="Godzina w ciągu dnia" type="number" min="0" max="23" />
                </template>
            </template>
            
          </template>


        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!report.deleted_at && !report.is_dependent && $page.props.can['delete admin module position']" class="text-red-600 hover:underline mr-5" tabindex="-1" type="button" @click="destroy">Usuń report</button>
          <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Zaktualizuj dane</loading-button>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo() {
    return {
      title: `${this.report.name}`,
    }
  },
  components: {
    LoadingButton,
    TextInput,
    TrashedMessage,
    MultiselectInput,
    ShtaxTextAreaInput,
    ShtaxCheckbox
  },
  layout: Layout,
  props: {
    report: Object,
    users: Array,
    cycles: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.report.name,
        description: this.report.description,
        command: this.report.command,
        is_dependent: this.report.is_dependent,
        period: this.report.period ? {'name': this.report.period, 'name_pl': this.cycles.find(element => element.name == this.report.period).name_pl} : null,
        day_of_month: this.report.day_of_month,
        hour_of_day: this.report.hour_of_day,
        users: this.report.users.map(user => {return {'id': user.id, 'name': user.first_name +' '+ user.last_name}})
      })
    }
  },
  methods: {
    update() {
      this.form.put(this.route('reports.update', {'report':this.report.id}))
    },
    destroy() {
      if (confirm('Jesteś pewien że chcesz usunąć wybrany raport?')) {
        // this.$inertia.delete(this.route('reports.destroy', {'report':this.report.id}))
      }
    },
    restore() {
      if (confirm('Jesteś pewien że chcesz przywrócić wybrany raport?')) {
        // this.$inertia.put(this.route('reports.restore', {'report':this.report.id}))
      }
    },
  },

  computed: {
  }
}
</script>
